"use client";
import React, { useState } from "react";

import Header from "../components/Header";
import CourseMenuLession from "../components/courses/CourseMenuLession";
import { useParams } from "react-router-dom";
import Lesson from "../components/courses/Lession";

const LessionPage = () => {
  const { courseId, lessonId } = useParams();

  return (
    <>
      <Header />
      <main data-router-wrapper>
        <section className="js-page page lessons " data-router-view="lessons">
          <main
            className="main"
            style={{ minHeight: "100vh", paddingTop: "40px" }}
          >
            <CourseMenuLession
              courseId={courseId}
              lessonId={lessonId}
            />
            <Lesson courseId={courseId} lessonId={lessonId} />
          </main>
        </section>
      </main>
    </>
  );
};

export default LessionPage;
